var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100%" } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "management-section-wrapper",
          staticStyle: { height: "100%" }
        },
        [
          _c(
            "v-main",
            {
              staticClass: "overflow-y-auto",
              staticStyle: { height: "100%" },
              attrs: { id: "scroll-target" }
            },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.dataToShow,
                  "hide-default-header": "",
                  "hide-default-footer": "",
                  "disable-pagination": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function(props) {
                      return [
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "data-table-td border-right" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.item.attribute) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "data-table-td" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(props.item.value) +
                                  "\n              "
                              ),
                              _vm.isTooBig(props.item.value)
                                ? _c(
                                    "md-tooltip",
                                    {
                                      staticClass: "return-to-tooltip",
                                      attrs: { "md-direction": "right" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(props.item.value) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d1c7a02", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1c7a02","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Molecules/DetailDataTable.vue
// module id = null
// module chunks = 